/**
 * Shown when the map's code could not be loaded at all — distinct from
 * `MapUnsupported`, which means the code loaded and the browser refused it a
 * WebGL2 context. The difference matters to the reader: one is worth a reload,
 * the other never will be.
 *
 * It sits BELOW the header rather than at the top of the screen, where it used
 * to be pinned: the header is the one piece of chrome that survives this
 * failure, and a notice laid over the search field hid the only control still
 * worth using. `top-28` clears the phone's two header rows and `md:top-20` the
 * single row from `md` up; the layout's atlas list pads itself to start under
 * this box (see `atlas_layout.tsx`).
 */
export default function MapUnavailable() {
  return (
    <div
      role="alert"
      data-testid="map-unavailable"
      className="absolute inset-x-3 top-28 z-20 mx-auto max-w-xl rounded-2xl bg-amber-50 px-4 py-3 text-sm text-amber-950 shadow-chrome ring-1 ring-amber-300 md:top-20"
    >
      <p className="font-display text-[17px] font-semibold">The map could not be loaded</p>
      <p className="mt-1 leading-relaxed">
        The map code did not arrive — often a stale page left open across a deploy, or a blocked request.
        Reloading usually fixes it. The atlas is listed below meanwhile, and every place links to its own page.
      </p>
    </div>
  )
}
